import "./widgets-core8.css";
import { defineComponent as m, openBlock as t, createElementBlock as r, Fragment as p, renderList as c, renderSlot as l } from "vue";
import { _ as u } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const a = /* @__PURE__ */ m({
  __name: "List",
  props: {
    items: {},
    itemId: { type: Function }
  },
  setup(n) {
    const e = n;
    return (s, d) => (t(), r("ul", null, [
      (t(!0), r(p, null, c(e.items, (o, i) => (t(), r("li", {
        key: e.itemId ? e.itemId(o) : i
      }, [
        l(s.$slots, "default", { item: o }, void 0, !0)
      ]))), 128))
    ]));
  }
}), k = /* @__PURE__ */ u(a, [["__scopeId", "data-v-c9846e29"]]);
export {
  k as default
};
//# sourceMappingURL=widgets-core.es10.js.map
